export default {
  boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.15)'
};